if(typeof BSS_B2B != 'undefined'){
  setTimeout(() => {
    const qv_elm = document.querySelector("#fancybox-wrap");
    if(qv_elm){
      const observer = new MutationObserver(() => {
       setTimeout(() => {
           BSS_B2B.cp.changeProductPrice(JSON.parse($("#bss-b2b-store-data").html()),false , false); 
       }, 100)
      })
      observer.observe(qv_elm, {childList: true, subtree: true})
    }
  }, 300)
}